<template>
    <div>
        <header class="form-title">
             记一笔
        </header>
        <p style="color: #9ea7b4;margin: 20px"> 记一笔不可删除和修改，以做凭证用 </p>
        <Form  :label-width="80"  >
            <FormItem label="收支类型:">
                <RadioGroup  v-model="sendData.type">
                    <Radio label="1" style="margin-right: 20px">支出</Radio>
                    <Radio label="2">收入</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="结算账户:">
                <Select  filterable v-model="sendData.discount"  style="width: 300px;">
                    <Option :value="k.id" v-for="(k,v) in BankList" :key="v" v-if="k.type!=6" placeholder="请选择">{{k.bankname}}</Option>
                </Select>
            </FormItem>
            <FormItem label="账户余额:">
                <strong>￥{{sendData.balance}}</strong>
            </FormItem>
            <FormItem label="结算类型:">
                <Select v-model="sendData.acctype" filterable  style="width: 300px">
                    <Option :value="k.id" v-for="(k,v) in sendTypeList" :key="v">{{k.name}}</Option>
                </Select>
            </FormItem>
            <FormItem label="记账金额:">
                <InputNumber  :max="99999999"   :min="0" v-model="sendData.money"   style="width: 300px"></InputNumber>
            </FormItem>
            <FormItem label="备注:">
                <Input  type="textarea" v-model="sendData.text" :maxlength="100" placeholder="最多输入100个字符" style="width: 300px"></Input>
            </FormItem><br>
            <FormItem label="图片:" style="margin-bottom: 0;height: 100px">
                <!--图片展示列表-->
                <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
                    <!--删除or查看按钮-->
                    <template v-if="item.status === 'finished'">
                        <Fy-Img
                                class="img"
                                :ImgSrc="item.url | filtImg(item.url)"
                        ></Fy-Img>
                        <div class="demo-upload-list-cover">
                            <Icon type="ios-eye-outline"  @click.native="handleView(index)"></Icon>
                            <Icon type="ios-trash-outline"  @click.native="handleRemove(item)"></Icon>
                        </div>
                    </template>
                    <!--加载进度条-->
                    <template v-else>
                        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                    </template>
                </div>
                <!--上传按钮组件-->
                <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :on-success="handleSuccess"
                        :before-upload="beforeUpload"
                        :format="['jpg','jpeg','png']"
                        :max-size="5120"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        multiple
                        type="drag"
                        :action="actionImgUrl"
                        style="display: inline-block;width:100px;">
                    <div style="width: 100px;height:100px;line-height: 100px;">
                        <Icon type="md-add" size="30" />
                    </div>
                </Upload>
                <!--弹框照片-->
                <Modal title="查看照片" v-model="visible" fullscreen transfer  >
                    <Carousel v-if="visible" v-model="isShowNumImg" >
                        <CarouselItem  v-for="(item,index) in uploadList" :key="index">
                            <img style="display: block;margin: auto" :src="item.url|filtImg(item.url)" />
                        </CarouselItem>
                    </Carousel>
                </Modal>
            </FormItem>
            <FormItem style="margin-bottom: 0;">
                <span style="color: #afafaf">(最多添加8张)</span>
            </FormItem>
            <FormItem>
                <ButtonGroup>
                    <Button type="primary" :loading="loading" @click="save(1)">
                        <span v-if="!loading">保存</span>
                        <span v-else>提交中</span>
                    </Button>
                    <Button type="warning" :loading="loading"  @click="save(2)">
                        <span v-if="!loading">保存再记</span>
                        <span v-else>提交中</span>
                    </Button>
                </ButtonGroup>
            </FormItem>
        </Form>
    </div>
</template>
<script>
    export default {
        components: {},
        data () {
            return {
                cid:"",
                sid:"",
                BankList:[],
                sendTypeList:[],
                sendData:{
                    type:'',//收支类型
                    balance:0,//余额
                    discount:'',//收支类型
                    acctype:'',//结算类型
                    money:0,//记账金额
                    text:'',//备注
                },
                uploadList: [],
                visible: false,
                isShowNumImg:0,
                actionImgUrl:this.ACTIONIMGURL,
                loading:false,
            }
        },
        watch: {
            'sendData.discount': {
                deep: true,
                handler: function (newVal, oldVal) {
                     this.BankList.some((item,index)=>{
                        if(item.id == newVal){
                            this.sendData.balance = item.money
                        }
                    })
                }
            },

        },
        mounted () {
            this.uploadList =  this.$refs.upload.fileList;
        },

        created: function() {
            //DOM更新完之前请求数据
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getBankList()
            this.getTradetypeList()
        },
        methods: {
            //获取银行卡
            getBankList(){
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.BankList =  res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //结算类型
            getTradetypeList(){
                this.$Api.getTradetypeList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.sendTypeList=[]
                        res.data.forEach((item,index)=> {
                            if (item.name != '销售退货' && item.name != '销售收入' && item.name != '采购支出' && item.name != '采购退货') {
                                this.sendTypeList.push(item)
                            }
                        })
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //更新
            /*查看大图*/
            handleView (data) {
                this.isShowNumImg=data
                this.visible = true;
            },
            /*查看大图*/
            handleView (data) {
                this.isShowNumImg=data
                this.visible = true;
            },
            /*删除上传*/
            handleRemove (file) {
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            },
            //文件上传之前时的钩子，
            beforeUpload(){
                const check = this.uploadList.length < 8;
                if (!check) {
                    this.$Notice.warning({
                        title: '图片最多上传8张'
                    });
                }
                return check;
            },
            //文件上传成功时的钩子，返回字段为 response, file, fileList
            handleSuccess (res, file) {
                const fileList = this.$refs.upload.fileList;
                if(res.code==200){
                    file.status=file.status
                    file.url=res.data.src
                    file.name=file.name
                    file.percentage=file.percentage
                    file.showProgress=file.showProgress
                }else {
                    this.$Message.warning('上传失败');
                }
            },
            //文件格式验证失败时的钩子，返回字段为 file, fileList
            handleFormatError (file,fileList) {
                this.$Message.warning('文件格式不正确');
            },
            handleMaxSize (file,fileList) {
                this.$Message.warning('文件不能超过5M');
            },
            save(num){ //num==1保存  num==2 在记
                if(this.sendData.type==''){
                    this.$Message.warning('请选择收支类型');return
                }
                if(this.sendData.discount==''){
                    this.$Message.warning('请选择收结算账户');return
                }
                if(this.sendData.acctype==''){
                    this.$Message.warning('请选择收结算类型');return
                }
                if(this.sendData.money<=0){
                    this.$Message.warning('请填写记账金额');return
                }
                var imgGroupSlep=''
                this.uploadList.forEach((item , index)=>{
                    imgGroupSlep+=item.url+','
                })
                if(this.sendData.type==1){
                    this.sendData.money = 0-this.sendData.money
                }
                this.loading=true
                this.$Api.addAccounts({
                    cid: this.cid,
                    sid: this.sid,
                    bankid: this.sendData.discount,
                    tradetypeid: this.sendData.acctype,
                    money:this.sendData.money,
                    remark: this.sendData.text,
                    img:imgGroupSlep,
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('添加成功');
                        if(num==2){
                            this.sendData.type=''
                            this.sendData.discount=''
                            this.sendData.acctype=''
                            this.sendData.text=''
                            this.sendData.money=0
                            this.sendData.balance=0
                            this.uploadList=[]
                        }else {
                          this.$router.push('/Remember')
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.loading=false
                }).catch( (err)=> {
                    this.loading=false
                });;
            },
        }
    }
</script>


<style  lang="scss" scoped>
    .form-title{
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .server-title{
        display: inline-block;
        text-align: center;width: 88%
    }
    .logo{
        width: 50px;
        height: 50px;
        margin: auto;
    }
    .ivu-form-item{
        height: 30px;
    }
    .demo-upload-list{
        display: inline-block;
        width: 100px;
        height: 100px;
        text-align: center;
        line-height: 100px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }

    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>